module.exports = __webpack_public_path__ + "img/Bågskytte.44b493b9.jpg";